let mutations = {
    setUserAccounts: function (state, user_accounts) {
        state.user_accounts = user_accounts;
    },

    setVisibleUser: function (state, user) {
        state.visible_user = user;
    },

    setAuthUser: function(state, user) {
        state.auth_user = user;
    },

    addRole: function (state, data) {
        if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty(data.role_cd)) {
            switch (data.role_cd) {
                case 'ACT_ADM':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'ACT_ADM': data.approved})
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('ANLYSIS')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'ANLYSIS': data.approved})
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('RPRT')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'RPRT': data.approved})
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('SUP')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'SUP': data.approved})
                    }
                    if (!state.user_accounts[data.account_index].rolesArray.hasOwnProperty('BILL')) {
                        state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'BILL': data.approved})
                    }
                    break;
                case 'ANLYSIS':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'ANLYSIS': data.approved})
                    break;
                case 'RPRT':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'RPRT': data.approved})
                    break
                case 'SUP':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'SUP': data.approved})
                    break
                case 'BILL':
                    state.user_accounts[data.account_index].rolesArray = Object.assign({}, state.user_accounts[data.account_index].rolesArray, {'BILL': data.approved})
                    break
            }
        }
    },

    deleteRole: function (state, data) {
        Vue.delete(state.user_accounts[data.account_index].rolesArray, data.role_cd)
        //remove ACT_ADM if you are removing any other role
        Vue.delete(state.user_accounts[data.account_index].rolesArray, 'ACT_ADM')
    },

    unselectAccount: function (state, index) {
        state.user_accounts[index].rolesArray = {}
        state.user_accounts[index].has_pending_approval = false
    },

    addAccountToList: function (state, user_account) {
        state.user_accounts.push(user_account);
    },

    approveRoles: function (state, data, success) {
        Vue.set(state.user_accounts, data.account_index, data.user_account);

        //addNewApprovedRoles to the visible_user (if necessary)
        var approvedRoles = Object.keys(data.user_account.rolesArray);
        approvedRoles.forEach(function (item) {
            if (!state.visible_user.approved_roles.includes(item)) {
                state.visible_user.approved_roles.push(item);
            }
        })

        if (typeof success === 'function') success();
    }
};

export default mutations;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/user/mutations.js